<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
        에이전트
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WSFinder</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Agent</a>
          </li>
      </ul>
    </div>
    <vcl-facebook v-if="loading"></vcl-facebook>
    <b-card v-else>
    <!-- <router-view @refresh="refresh()"></router-view> -->
      <div>
        <span class="font-weight-bold">
          {{model.host || '-'}}
          ({{(model.ip_addr_public ? model.ip_addr_public : model.ip_addr) || '-'}})
        </span>
        <b-badge variant="success" v-if="model.alive == true">온라인({{model.ms}} ms)</b-badge>
        <b-badge v-else>오프라인</b-badge>
        <b-badge v-if="model.alive == true && model.status && model.status.running && model.status.is_real_time == false" variant="primary">
          수동 점검중
        </b-badge>
        <b-badge v-else-if="model.alive == true && model.status && (model.setting.realtime_mode || model.status.scaning_real_time == true)" variant="warning">
          실시간 모니터링중
        </b-badge>
        <span class="float-right">설치일 : {{model.created_at | datetime}} </span>
      </div>
      <hr>
      <b-card v-if="!quick_setting_status">
        <b-row>
          <b-col md="4" class="text-center" style="height:180px;">
            <div
              @click="modal_modify = true"
              :style="`cursor:pointer;display: inline-block; background-color: ${model.status.last_detect_count ? 'orange' : 'skyblue'}; border:1px solid ${model.status.last_detect_count ? 'orange' : 'skyblue'}; width:150px; font-weight: 800; height:150px; border-radius:75px; text-align:center; margin:0 auto; font-size:15px; color:#fff; vertical-align:middle; line-height:150px`"
            >
              <small class="font-weight-bold">{{model.name}}</small>
            </div>
          </b-col>
          <b-col md="8" style="height:fit-content;">
            <table class="w-100">
              <thead>
                <th class="p-1">#</th>
                <th class="p-1">시각</th>
                <th class="p-1">상세</th>
              </thead>
              <tbody>
                <tr>
                  <td class="p-1">최근 점검 결과</td>
                  <td class="p-1" v-if="model && model.status">{{model.status.last_scan_date | datetime}} </td>
                  <td class="p-1" v-else>-</td>
                  <td class="p-1">
                    전체 : {{model.status.last_scan_count || 0 }} 파일 점검
                  </td>
                  <td>
                    <b-btn block class="float-right" size="sm" variant="primary" @click="modal_modify = true"> 이름 변경</b-btn>
                  </td>
                </tr>
                <tr>
                  <td class="p-1">최근 탐지 상세</td>
                  <td class="p-1" v-if="model && model.status">{{model.status.last_detect_date | sdate}} </td>
                  <td class="p-1" v-else>-</td>
                  <td class="p-1">
                    전체 : {{model.status.last_detect_count || 0 }} 파일 점검
                  </td>
                  <td>
                    <b-btn block class="float-right btn-add" size="sm" variant="success" @click="modal_upgrade = true"> 업그레이드</b-btn>
                  </td>
                </tr>
                <tr>
                  <td class="p-1">최근 서버와 연결된 시간</td>
                  <td class="p-1" v-if="model && model.touched_at">{{model.touched_at | sdate}} </td>
                  <td class="p-1" v-else>-</td>
                  <td class="p-1">
                    -
                  </td>
                  <td>
                    <b-btn block class="float-right" size="sm" variant="danger" @click="del_confirm = true"> 삭제</b-btn>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <!-- 메모리 차트 영역 -->
          <b-col class="fadeIn fadeOut" :md="model.status.system_cpu_info && model.status.system_cpu_info.usages && model.status.system_cpu_info.usages.length > 0 ? 4 : 6">
            <div v-if="model.chart.memory.series && model.chart.memory.series.length > 0">
              <VueApexCharts type="area" height="150" ref="_chart_memory" :options="model.chart.memory" :series="model.chart.memory.series" />
            </div>
          </b-col>
          <!-- cpu 차트 영역 -->
          <b-col class="fadeIn fadeOut" :md="model.status.system_cpu_info && model.status.system_cpu_info.usages && model.status.system_cpu_info.usages.length > 0 ? 4 : 6">
            <div v-if="model.chart.memory.series && model.chart.memory.series.length > 0">
              <VueApexCharts type="area" height="150" ref="_chart_cpu" :options="model.chart.cpu" :series="model.chart.cpu.series" />
            </div>
          </b-col>
          <!-- cpu work load -->
          <b-col class="fadeIn fadeOut" md="4">
            <div v-if="model.status.system_cpu_info && model.status.system_cpu_info.usages && model.status.system_cpu_info.usages.length > 0">
              <VueApexCharts type="heatmap" height="140" ref="_chart_workload" :options="model.chart.workload" :series="model.chart.workload.series" />
            </div>
          </b-col>
        </b-row>
        <hr>
        <b-row class="text-center">
          <b-col>
            <b-form-group>
              <div slot="label" class="font-weight-bold">
                HOST
              </div>
              {{model.host}}
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <div slot="label" class="font-weight-bold">
                IP
              </div>
              <span v-if="!model.ip_addr_public || !model.ip_addr_private">{{model.ip_addr}}</span>
              <span v-else>
                <span v-if="model.ip_addr_public">
                  <span v-if="model.ip_addr_public == model.ip_addr_private">
                    {{ model.ip_addr_public }}
                  </span>
                  <span v-else>
                    {{ model.ip_addr_public }} /  {{ model.ip_addr_private }}
                  </span>
                </span>
                <span v-else>
                  {{ model.ip_addr_private }}
                </span>
              </span>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <div slot="label" class="font-weight-bold">
                운영체제
              </div>
              {{model.os_type}}
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <div slot="label" class="font-weight-bold" v-b-tooltip.hover.right title="업데이트 가능한 버전이 있을 경우 알림이 표시됩니다">
                <span>
                  버전
                  <Bell style="display: inline-block;" :size="20" :count="1" v-if="!is_latest()"/>
                </span>
              </div>
              {{model.version}}
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <div slot="label" class="font-weight-bold">
                위변조 사용 여부
              </div>
              <strong>
                <b-badge class="" :variant="model.setting.forgery_mode ? 'success' : 'default'" >{{ model.setting.forgery_mode ? '사용중' : '미사용' }}</b-badge>
              </strong>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="6" v-if="model.setting.scan_list && model.setting.scan_list.length > 0">
            <center class="m-1">모니터링 폴더 미리보기</center>
            <white-Path :preview="true" :white_path="model.setting.scan_list || []" :show="true" @save="index = 0"></white-Path>
          </b-col>
          <b-col md="6" v-else>
            <center class="m-1">모니터링 폴더 설정 안됨</center>
          </b-col>
          <b-col md="6" v-if="model.setting.white_path && model.setting.white_path.length > 0">
            <center class="m-1">예외 경로 미리보기</center>
            <white-Path :preview="true" :white_path="[].concat(model.setting.white_path || []).concat(model.setting.white_file || [])" :show="true" @save="index = 0"></white-Path>
          </b-col>
          <b-col md="6" v-else>
            <center class="m-1">예외 경로 설정 안됨</center>
          </b-col>
        </b-row>
      </b-card>
      <hr>
      <template v-if="quick_setting_status" class="animated fadeIn fadeOut">
        <SettingQuickSetup
          v-if="quick_setting_status"
          :is_one="is_one"
          :is_first="is_first"
          :dir="dir"
          :scan_list="scan_list"
          :now_setting="model.setting"
          :os_type="model.os_type"

          @status="() => { quick_setting_status = false; is_first = false }"
          @remove="remove_select"
          @clear="clear"
          @get_path="(x) => { this.get_path(x) }"
          @save_quick="(setting) => { this.model = Object.assign({}, this.model, { setting : setting }); this.save_setting() }"
        >
        </SettingQuickSetup>
      </template>
      <b-tabs v-else active-nav-item-class="font-weight-bold text-uppercase text-danger" v-model="index">
        <b-tab @click="folder()" title="대상 폴더">
          <folderSet
            :os_type="model.os_type"
            :is_refresh="model.alive"
            :show="dir.length"
            :item="dir"
            :scan_list="scan_list"
            :scan_list_history="model.setting.scan_list_history"
            :white_path="white_path"
            :white_file="white_file"
            :disk_list="disckStatus"

            @path="get_path"
            @save="folder_save"
            @remove="remove_select"
            @clear="clear"

            @add_white_list_file="add_white_list_file"
            @add_white_list="add_white_list"
            @add_scan_list="add_scan_list"

          />
        </b-tab>
        <b-tab title="설정">
          <b-row class="text-center">
            <b-col md="2">
            </b-col>
            <b-col md="4">
              <b-button block size="sm" variant="success" @click="save_setting" :disabled="runStatus" class="pr-2 pl-2 btn-add" style="min-width: 5.0rem;">
                {{ runStatus ? "점검중, 잠시 후 다시 시도하세요" : '저장' }}
              </b-button>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <b-button block size="sm" variant="warning" @click="apply_modal = true">
                  이 설정을 다른 서버에 적용
                </b-button>
                <br>
                <small class="font-weight-bold text-danger">* 현재 설정 항목이 선택한 에이전트 전체에 적용됩니다.</small>
              </b-form-group>
            </b-col>
            <b-col md="4">
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col>
              <b-form-group :label-cols="4">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="점검시 사용하는 정책을 설정합니다">
                    * 점검 정책
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>

                </div>
                <b-form-checkbox-group id="ph_status" v-model="model.setting.rule">
                  <b-form-checkbox value="Regex">정규식</b-form-checkbox>
                  <b-form-checkbox value="Hash">해시</b-form-checkbox>
                  <b-form-checkbox value="Url">Url</b-form-checkbox>
                  <b-form-checkbox value="Ssdeep">유사도</b-form-checkbox>
                  <b-form-checkbox value="OB">난독화</b-form-checkbox>
                  <b-form-checkbox value="ML" v-if="is_show_beta()">딥러닝</b-form-checkbox>
                </b-form-checkbox-group>
                <b-form-input v-if="model.setting.rule.indexOf('ML') > -1" placeholder="인공지능 URL 을 입력하세요" type="text" v-model="model.setting.url"></b-form-input>
              </b-form-group>
              <br>
              <b-form-group :label-cols="4">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="실시간 모니터링 여부를 설정합니다">
                    실시간 모니터링
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </div>
                <b-form-radio-group v-model="model.setting.realtime_mode">
                  <b-form-radio :value="true">사용</b-form-radio>
                  <b-form-radio :value="false">미사용</b-form-radio>
                </b-form-radio-group>
              </b-form-group>

            </b-col>
            <b-col class="border-left">
              <b-form-group :label-cols="4" label="">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="점검 일정을 설정합니다 최대 10개까지 설정 가능하며 새벽 또는 서버 자원의 부하가 없는 시간대를 권장합니다">
                    * 점검 일정
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                    <br>
                    <small>최대 10개의 일정 설정 가능</small>
                  </span>
                </div>
              <Schedule :now_schedule="model.setting.schedule" @save="x => model.setting.schedule = x" :hide_text="true" />
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col>
              <b-form-group :label-cols="2">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="탐지된 웹쉘 파일의 백업 여부를 설정합니다 백업 후 해당 파일을 웹에서 접근할 수 없습니다 권장되는 설정이지만 오탐의 파일이 백업될 수 있습니다">
                    격리 모드
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </div>
                <b-form-radio-group style="display:inline-block" v-model="model.setting.backup_mode">
                  <b-form-radio :value="false">수동</b-form-radio>
                  <b-form-radio :value="true">자동</b-form-radio>
                </b-form-radio-group>
                [
                <b-form-checkbox-group style="display:inline-block" v-model="model.setting.backup_type_list" :disabled="!model.setting.backup_mode">
                  <b-form-checkbox value="Regex">정규식</b-form-checkbox>
                  <b-form-checkbox value="Hash">해시</b-form-checkbox>
                  <b-form-checkbox value="Url">Url</b-form-checkbox>
                  <b-form-checkbox value="Ssdeep">유사도</b-form-checkbox>
                  <!-- <b-form-checkbox value="OB">난독화</b-form-checkbox> -->
                  <!-- <b-form-checkbox value="ML">Machine Learning</b-form-checkbox> -->
                </b-form-checkbox-group>
                ] <br> <small class="text-danger">* 난독화는 자동 격리를 사용할 수 없습니다</small>
              </b-form-group>
            </b-col>
            <b-col class="border-left">
              <b-form-group :label-cols="3">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.bottom title="격리 경로를 설정합니다 해당 경로가 존재하지 않을 경우 해당 경로에 폴더를 자동으로 생성합니다 기본값은 윈도우의 경우 'C:\wfinder_backup', 리눅스의 경우 '/opt/f1/wsfinder_backup'이 설치시 기본값으로 지정됩니다">
                    격리 경로
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </div>
                <b-input-group>
                  <b-form-input placeholder="경로를 입력하세요" id="input-small3" type="text" v-model="model.setting.backup_path"></b-form-input>
                  <b-button size="sm" variant="link" @click="modal_scan_list_history = true">이전 기록</b-button>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="text-center">
            <b-col>
              <hr>
              <b-button class="btn-addition" style="position: relative; top:-30px; width: 80%;" v-b-toggle.collapse-1-inner size="sm" variant="light">추가 옵션</b-button>
            </b-col>
          </b-row>

          <b-collapse id="collapse-1-inner" class="mt-2">
            <b-row>
              <b-col>
                <b-form-group :label-cols="3">
                  <div slot="label" class="font-weight-bold">
                    <span v-b-tooltip.hover.right title="점검 대상에서 확장자로 필터링할 수 있습니다 특정 파일만 모니터링 하는 경우에 사용합니다">
                      확장자 설정
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>
                    </span>
                  </div>
                  <b-input-group>
                    <b-form-input type="text" v-model="converter"></b-form-input>
                  </b-input-group>
                  <small class="help-block">확장자 설정, 예) txt,php,aspx,js, ...</small>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group :label-cols="3">
                  <div slot="label" class="font-weight-bold">
                    <span v-b-tooltip.hover.right title="모니터링하는 폴더에서 조건 이하의 크기를 가진 파일만 검사합니다">
                      최대 파일 사이즈
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>
                    </span>
                  </div>
                  <b-input-group>
                      <b-form-input type="number" v-model="model.setting.max_filesize"></b-form-input>
                  </b-input-group>
                  <small class="help-block">기본 : 10M</small>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group :label-cols="3">
                  <div slot="label" class="font-weight-bold">
                    <span v-b-tooltip.hover.right title="업데이트 되는 시스템 패턴을 자동으로 적용하여 점검하는지 여부를 설정합니다 해당 설정은 활성화를 권장합니다 미사용할 경우 업데이트된 패턴을 수동으로 업데이트할 수 있습니다">
                      시스템 패턴 자동 적용
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>
                    </span>
                    <!-- 시스템 패턴 자동 적용 -->
                  </div>
                  <b-form-radio-group v-model="model.is_allow_system">
                    <b-form-radio :value="true">사용</b-form-radio>
                    <b-form-radio :value="false">미사용</b-form-radio>
                    <b-button class="btn-add" size="sm" variant="success" @click="system_pattern_manual" :disabled="model.is_allow_system == true || model.available_system_pattern_count < 1 || this.model.is_testing">
                      <b-badge pill variant="warning" >{{ model.available_system_pattern_count | number }}</b-badge>
                      <span v-if="!model.is_testing">
                        시스템 패턴 추가 적용이 가능합니다
                      </span>
                      <span v-else>
                        테스트 요청, 메일로 결과를 알려 드립니다
                      </span>
                    </b-button>
                  </b-form-radio-group>
                  <small class="text-danger">사용을 권장합니다</small>
                </b-form-group>
              </b-col>
            </b-row>
            <hr>
          <b-row class="text-center">
            <b-col sm="12">
              <p style="display:inline-block; cursor: pointer;" @click="model.setting.limit_mode = !model.setting.limit_mode">
                <span v-b-tooltip.hover.right title="설치된 서버의 자원을 모니터링 합니다 설정한 한계치 도달시 메일 알림을 수신할 수 있습니다">
                  자원 모니터링 알림
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </span>
                <!-- <span class="mr-3">자원 모니터링 알림</span> -->
                <i v-if="model.setting.limit_mode" class="fa fa-refresh fa-spin"></i>
              </p>
              <c-switch class="float-right" color="success" label variant="pill" v-model="model.setting.limit_mode"/>
              <br>
              <small class="text-danger">시스템 자원이 임계치 이상일 경우 최초 1회 알림 발생 되며, 정상 기준이하시 재알림이 가능합니다. 임계치는 90%, 정상 기준은 60% 를 권장합니다 </small>
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col sm="2" class="mt-2">CPU 임계치(90%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="model.setting.limit_cpu"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">RAM 임계치(90%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="model.setting.limit_ram"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">Disk 임계치(90%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="model.setting.limit_disk"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row class="text-center">
            <!-- 여기서 라인 나눔 -->
            <b-col sm="2" class="mt-2">CPU 정상(60%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="model.setting.resolve_cpu"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">RAM 정상(60%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="model.setting.resolve_ram"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">Disk 정상(60%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="model.setting.resolve_disk"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          </b-collapse>
        </b-tab>
        <!-- 점검 탭 -->
        <b-tab title="점검" v-if="(model.status && model.alive)">
          <b-row>
            <b-col md="3">
              <b-form-group v-if="model && model.status">
                에이전트 상태
              </b-form-group>
            </b-col>
            <b-col md="2">
              {{model.status.running && model.status.is_real_time == false ? (scan_status.stopping ? "중지중" : `수동 점검중`) : '대기중'}}
              <span v-if="model.status.running && model.status.is_real_time == false">
                <i class="fa fa-refresh fa-spin"></i>
              </span>
            </b-col>
            <b-col md="2">
              <b-button block v-if="model.status && !scan_status.running" size="sm" variant="primary" @click="start_scan" :disabled="!model.ms">
                지금 시작
              </b-button>
              <b-button block v-else size="sm" variant="danger" @click="stop_scan" :disabled="scan_status.stopping || !model.status.percentFile">
                <b-spinner v-if="model.status && !model.status.percentFile" small type="grow"></b-spinner>
                {{ scan_status.running && model.status && !model.status.percentFile ? '준비중' : '중지'}}
              </b-button>
            </b-col>
            <b-col md="6"></b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group v-show="runStatus">
                점검 시작 -
                <span v-if="model.status && !model.status.percentFile">준비중</span>
                <span v-else> {{model.status.scan_date | datetime}}</span>
                <span class="text-danger float-right">* 파일 검색과 확인이 동시에 이루어지며 진행 상황은 달라질 수 있습니다. </span>
              </b-form-group>
            </b-col>
          </b-row>
          <hr v-if="runStatus">
          <b-progress v-show="runStatus" class="mt-2 animated fadeIn fadeOut" :max="model.status.percentFolder != 0 ? 200 : 100" show-value ref="progressbar">
            <b-progress-bar v-if="model.status.percentFolder != 0" :label="`${model.status.percentFolder || 0} %`" show-progress animated :precision="1" :value="model.status.percentFolder || 0" variant="info"></b-progress-bar>
            <b-progress-bar :label="`${model.status.percentFile || 0} %`" show-progress animated :precision="1" :value="model.status.percentFile || 0" variant="dark"></b-progress-bar>
          </b-progress>
          <hr>
          <b-row>
            <b-col>
              <b-form-group :label-cols="3" label="최근 점검 상태" v-if="runStatus">
              <span> <b-badge pill variant="dark" >파일</b-badge> : {{model.status.scan_count}} of {{model.status.scan_count_left}}  점검 완료 - {{ model.status.percentFile || 0 }} % </span> <br>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group :label-cols="3" :label="`최근 프로세스 시작`" v-if="model && model.status">
                <label v-if="scan_status.running && !model.status.percentFile">준비중.....</label>
                <label v-else>{{model.status && model.status.start | datetime}}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group :label-cols="3" :label="`최근 점검 정보`" v-if="model && model.status"><label>{{model.updated_at | datetime}} / 전체 : {{model.status.last_scan_count || 0}} 파일</label></b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group :label-cols="3" :label="`최근 탐지 정보`" v-if="model && model.status"><label>{{model.updated_at | datetime}} / 전체 : {{model.status.last_detect_count || 0}} 탐지 </label></b-form-group>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="점검" v-else>
          <b-row>
            <b-col md="5">
              에이전트 오프라인
            </b-col>
          </b-row>
        </b-tab>
        <!-- 탐지 탭 -->
        <b-tab @click="$refs._dl && $refs._dl.refresh()">
          <template slot="title">
            탐지이력
            <span class="badge badge-danger">{{`${detect_item || 0}`}}</span>
          </template>
          <b-table ref="_dl" striped hover small class="table_add" :items="getDetect" :fields="detect_fields" :current-page="so_detect.currentPage" :per-page="so_detect.perPage" v-show="detect_item">
            <template slot="created_at" slot-scope="row">{{ row.item.created_at | datetime }}</template>
            <template slot="path" slot-scope="row">{{row.item.path}}</template>
            <template slot="type" slot-scope="row">{{ parser_type(row.item) }}</template>
            <template slot="select" slot-scope="row">
              <b-btn size="sm" @click="detect_select(row.item)" variant="dark">상세</b-btn>
              <b-btn size="sm" @click="backup(row.item)" variant="warning"> 격리 </b-btn>
              <b-btn class="btn-add" size="sm" @click="detect_exception(row.item)" variant="success"> 예외 </b-btn>
              <b-btn size="sm" @click="detect_download(row.item)" variant="primary"> 다운로드 </b-btn>
              <!-- <b-btn size="sm" @click="backup_remove_raw(row.item)" variant="danger"> 삭제 </b-btn> -->
            </template>
          </b-table>
          <hr>
          <b-col class="md-4" v-if="detect_item">
            <b-pagination size="sm"  align="center" :total-rows="detect_item" :per-page="so_detect.perPage" v-model="so_detect.currentPage" prev-text="<" next-text=">" />
          </b-col>
          <template v-if="!detect_item">
            <strong>탐지 이력이 없습니다.</strong>
          </template>
          <!-- 상세보기 모달 -->
          <b-modal size="lg" ref="detect_modalRef" title="" ok-only>
            <div class="text-center h6 w-100">
              <table class="text-center h5 w-100">
                <thead>
                  <tr>
                    <th style="background-color:orange; border-radius: 12px;;" colspan="2">탐지 정보</th>
                  </tr>
                </thead>
                <tbody class="h6">
                  <tr>
                    <td class="p-2">에이전트</td>
                    <td class="p-2">{{model.name}} ({{model.host}})</td>
                  </tr>
                  <tr>
                    <td class="p-2">IP 정보</td>
                    <td class="p-2">{{ model.ip_addr_public }} / {{ model.ip_addr_private }}</td>
                  </tr>
                  <tr>
                    <td class="p-2">탐지 시각</td>
                    <td class="p-2">{{detect_model.created_at | datetime}}</td>
                  </tr>
                  <tr>
                    <td class="p-2">격리(백업)</td>
                    <td class="p-2 text-danger">{{detect_model.is_backup ? `예` : `아니오`}}</td>
                  </tr>
                  <tr>
                    <td class="p-2">타입</td>
                    <td class="p-2">{{detect_model && detect_model.description ? detect_model.description.type : '-'}}</td>
                  </tr>
                  <tr>
                    <td class="p-2">패턴</td>
                    <td class="p-2">{{detect_model && detect_model.description ? detect_model.description.code : '-'}}</td>
                  </tr>
                  <tr>
                    <td class="p-2">라인</td>
                    <td class="p-2" v-if="detect_model && detect_model.description">{{detect_model.description.numerical > 0 ? detect_model.description.numerical : '-'}}</td>
                    <td class="p-2" v-else>-</td>
                  </tr>
                </tbody>
              </table>
              <b-btn @click="copyText('ph_content')" size="sm" variant="primary" block> 경로 </b-btn>
              <pre class="mt-4" ref="ph_content" id="ph_content">{{detect_model.path}}</pre>
              <b-btn @click="copyText('ph_data')" size="sm" variant="primary" block> 탐지 데이터(해당 라인의 일부만 표시) </b-btn>
              <pre class="mt-4" ref="ph_data" id="ph_data" v-if="detect_model && detect_model.description">{{detect_model.description.value ? detect_model.description.value : '-'}}</pre>
            </div>
          </b-modal>
        </b-tab>
        <!-- 결과 탭 -->
        <b-tab @click="$refs._rl && $refs._rl.refresh()">
          <template slot="title">
            점검이력
            <span class="badge badge-primary">{{`${result_item || 0}`}}</span>
          </template>
          <b-table ref="_rl" striped hover small fixed class="table_add" response :items="getResult" :fields="result_fields" :current-page="so_result.currentPage" :per-page="so_result.perPage" v-show="result_item">
            <template slot="scan_time" slot-scope="row">
              {{ row.item.scan_time | datetime }}
              ({{row.item.scanning_time}})
            </template>
            <template slot="scan_folder" slot-scope="row">{{row.item.scan_folder | number}} 개</template>
            <template slot="scan_count" slot-scope="row">{{row.item.scan_count | number}} 개</template>
            <template slot="detect_count" slot-scope="row">{{row.item.detect_count | number}} 개 탐지</template>
            <template slot="select" slot-scope="row">
              <b-button class="btn-secondary" size="sm" @click="result_select(row.item)">상세</b-button>
            </template>
          </b-table>
          <hr>
          <template v-if="!result_item">
            <strong>점검 이력이 없습니다.</strong>
          </template>
          <b-col class="md-4" v-if="result_item">
            <b-pagination size="sm"  align="center" :total-rows="result_item" :per-page="so_result.perPage" v-model="so_result.currentPage" prev-text="<" next-text=">" />
          </b-col>
          <b-modal size="xl" ref="result_modalRef" title="" ok-only>
            <ResultDetail :id="result_model.id" />
          </b-modal>
        </b-tab>
        <!-- 격리 탭 -->
        <b-tab @click="save_box()" >
          <template slot="title">
            격리소
            <span class="badge badge-warning">{{`${safe_box ? safe_box.length : 0}`}}</span>
          </template>
          <b-table ref="safe_list" striped hover small fixed class="table_add" :items="safe_box" :fields="safe_fields" :current-page="so_isolation.currentPage" :per-page="so_isolation.perPage" v-show="safe_box && safe_box.length">
            <template slot="path" slot-scope="row">{{row.item.path}}</template>
            <template slot="hash" slot-scope="row">{{row.item.hash && row.item.hash.indexOf('.') > -1 ? row.item.hash.split('.')[0] : row.item.hash}}</template>
            <template slot="created_at" slot-scope="row">{{ row.item.data | datetime }}</template>
            <template slot="select" slot-scope="row">
              <b-btn class="btn-add" size="sm" @click="backup_restore(row.item)" variant="success">복원</b-btn>
              <b-btn class="btn-add" size="sm" @click="backup_exception(row.item)" variant="success">예외처리</b-btn>
              <b-btn size="sm" @click="backup_remove_modal = true; remove_info = row.item; $refs.safe_list.refresh()" variant="danger">삭제</b-btn>
              <b-btn size="sm" @click="backup_download(row.item)" variant="primary">다운로드</b-btn>
            </template>
          </b-table>
          <template v-if="!safe_box || !safe_box.length">
            <tr>
              <th>격리된 파일이 존재하지 않습니다</th>
            </tr>
          </template>
          <b-col class="md-4" v-if="this.safe_box && this.safe_box.length">
            <b-pagination size="sm"  align="center" :total-rows="this.safe_box && this.safe_box.length" :per-page="so_isolation.perPage" v-model="so_isolation.currentPage" prev-text="<" next-text=">" />
          </b-col>
          <b-modal size="lg" v-model="backup_remove_modal" @ok="backup_remove(remove_info)" ref="safe_modalRef" title="Remove">
            <p>
              Are you sure Remove it ?
            </p>
            <hr>
            <p>{{remove_info.path}} </p>
          </b-modal>
        </b-tab>
        <!-- <b-tab>
          <template slot="title">
            예외
            <span class="badge badge-success">{{`${model.setting && model.setting.white_path ? model.setting.white_path.length : 0}`}}</span>
          </template>
          <white-Path :press="false" :show="true" :white_path="model.setting.white_path || []" @add="add_white_path" @save="save_setting" @remove="remove_path" @clear="model.setting.white_path = []"></white-Path>
        </b-tab> -->
        <b-tab>
          <template slot="title">
            위변조
            <b-img v-if="model && model.setting.forgery_mode" rounded src="img/checked.png" width="15" class="ml-1 mt-1 mb-1"></b-img>
          </template>
          <div>
            <b-jumbotron>
              <template v-if="model.setting.forgery_mode" slot="header">
                <b-img style="display: inline-block; width: 5%;" rounded :src="'img/checked.png'" class="mr-2"></b-img>
                <p style="display: inline-block;" class="h1">
                  위변조 설정이 활성화 되어 있습니다
                </p>
              </template>
              <template v-else slot="header">
                <p class="h1 font-weight-bold">
                  위변조 설정을 활성화하세요!
                </p>
              </template>

              <template slot="lead">
                <p>
                  지정한 폴더의 하위 폴더 및 파일 위변조 여부를 탐지합니다. 설정 및 백업 파일의 변경 여부를 모니터링하세요
                </p>
                <p>
                  설정한 폴더를 확인하세요! 변경은 설정 페이지에서 가능합니다
                </p>
                <b-row>
                  <b-col>
                    <div class="text-center" v-if="model.setting.forgery_mode && model.setting.snapshot.watching.length">
                      <span style="position: relative; top: 1.8rem; background-color: #e4e7ea; font-weight: bold; padding: 0 15px;">
                        위변조 점검 폴더
                      </span>
                      <hr>
                    </div>
                    <small v-for="(item, index) in model.setting.snapshot.watching" v-bind:key="index+'_watching'">
                      {{item}}
                    </small>
                  </b-col>
                  <b-col>
                    <div class="text-center" v-if="model.setting.forgery_mode && model.setting.snapshot.watching.length">
                      <span style="position: relative; top: 1.8rem; background-color: #e4e7ea; font-weight: bold; padding: 0 15px;">
                        예외 폴더
                      </span>
                      <hr>
                    </div>
                    <small v-for="(item, index) in model.setting.snapshot.white_path" v-bind:key="index+'_white_path'">
                      {{item}}
                    </small>
                  </b-col>
                  <b-col>
                    <div class="text-center" v-if="model.setting.forgery_mode && model.setting.snapshot.watching.length">
                      <span style="position: relative; top: 1.8rem; background-color: #e4e7ea; font-weight: bold; padding: 0 15px;">
                        예외 파일
                      </span>
                      <hr>
                    </div>
                    <small v-for="(item, index) in model.setting.snapshot.white_file" v-bind:key="index+'_white_file'">
                      {{item}}
                    </small>
                  </b-col>
                </b-row>
              </template>
              <hr>
              <template>
                <b-button block variant="warning" to="/integrity/wsfinder">
                  <span v-if="model.setting.snapshot.watching && model.setting.snapshot.watching.length > 0">
                    설정 변경하기 :D
                  </span>
                  <span v-else>
                    지금 시작하기 :D
                  </span>
                </b-button>
              </template>
            </b-jumbotron>
          </div>
        </b-tab>
      </b-tabs>
      <b-modal size="xl" ref="scan_modalRef" title="" ok-only>
        <ResultDetail :result_data="result"/>
      </b-modal>
      <b-modal title="Delete"  class="modal-danger" v-model="del_confirm" @ok="remove" @cancel="del_nickname = '';" header-bg-variant="danger" ok-variant="danger">
        <p> 에이전트 삭제 시,</p>
        <p>서버에서도 삭제 명령을 수행해야 합니다.</p>
        <p>
          서버에서 자동으로 삭제되지 않습니다.
        </p>
        <p>메뉴얼을 참고하여 삭제하십시오.</p>
        <p> <b> * 에이전트 이름 확인 </b> </p>
        <p> 삭제할 에이전트 이름 입력 : {{model.name}}  </p>
        <b-form-input v-model="del_nickname" placeholder="삭제할 서버이름을 입력하세요."></b-form-input>
      </b-modal>

      <b-modal hide-footer title="해당 정책을 다른 에이전트에 적용" size="xl" v-model="apply_modal" header-bg-variant='warning'>
        <b-badge variant="success" v-for="(item, index) in apply_all_server" :key="index+'_a'" class="m-1">
          <h6 @click="multi_remove(index)" style="cursor:pointer;">{{item.name}} <span class="m-1" style="cursor:pointer;">X</span></h6>
        </b-badge>
        <hr>
        <agent-List :agent_id="model.id" :list_selected="apply_all_server" :only_select="true" :view_detail="true" :server_agent="server_agent" @multi_clear="multi_clear" @multi_all="multi_all" @multi_one="multi_one"></agent-List>
        <hr>
        <b-button block variant="warning" @click="apply_confirm_modal = true" class="m-1">적용</b-button>
        <b-button block variant="info" @click="apply_modal = false" class="m-1">닫기</b-button>
      </b-modal>

      <b-modal hide-footer title="Confirm" size="xm" v-model="apply_confirm_modal" header-bg-variant='danger'>
        Are you sure apply setting to selected agent ?
        <hr>
        <b-button block variant="danger" @click="multi_save" class="m-1">적용</b-button>
        <b-button block variant="info" @click="apply_confirm_modal = false" class="m-1">닫기</b-button>
      </b-modal>
      <hr>
      <b-button v-if="quick_setting_status == false" class="float-left" variant="link" @click="quick_setting_status = true">빠른 설정 시작</b-button>
      <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> 목록으로 </b-button>

      <b-modal title="수정"  class="modal-info" v-model="modal_modify" @ok="apply" header-bg-variant="info" ok-variant="info">
        <p> 서버의 이름을 수정할 수 있습니다. </p>
        <p> 변경할 이름을 입력하세요. 초기 서버 이름은 호스트명입니다 </p>
        <p> <b> * 서버 이름 확인 </b> </p>
        <p> 변경 전 서버 이름 : {{model.name}}  </p>

        <b-form-input v-model="modify_nickname" placeholder="변경할 서버 이름을 입력하세요"></b-form-input>
      </b-modal>

      <b-modal title="업그레이드"  class="modal-success" v-model="modal_upgrade" @ok="upgrade" header-bg-variant="success" ok-variant="success">
        <p>에이전트를 업그레이드 하시겠습니까 ?</p>
        <p> 현재 버전({{model.version}})에서 최신 버전으로 업그레이드 합니다.</p>
      </b-modal>
      <b-modal title="백업 경로 기록"  class="modal-info" v-model="modal_scan_list_history" @ok="modal_scan_list_history = false" ok-only header-bg-variant="info" ok-variant="info">
        <p v-if="!model.setting.backup_path_history || !model.setting.backup_path_history.length">이전 데이터가 없습니다</p>
        <table v-else>
          <thead class="text-center font-weight-bold border-bottom">
            <tr>
              <td>
                변경 시각
              </td>
              <td>
                변경 이전 폴더 목록
              </td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(x, index) in model.setting.backup_path_history" v-bind:key="index+'_b'">
              <td class="text-center" style="width: 40%">
                {{x.updated_at | sdate}}
              </td>
              <td>
                <p class="m-1">{{ x.target }}</p>
                <!-- <p class="m-1" v-for="(y, index) in x.target_sub">{{y}}</p> -->
                <!-- TODO : 향후 이전 기록 바로 적용 추가 될 수 있음 -->
              </td>
            </tr>
          </tbody>
        </table>
      </b-modal>
    </b-card>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
